import React from 'react';
import Typography from '@mui/material/Typography';

interface IRowProps {
  hit: any;
}

const HSCodesData: React.FC<IRowProps> = ({ hit }) => {
  return (
    <>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['HS Code']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Section}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Chapter}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Product Name']}
        </Typography>
      </div>
    </>
  );
};

export default HSCodesData;
